import { NotificationTypes } from '@accounts/accounts-alerts/accounts-alerts.interface';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InfoItem } from '@frk/eds-components';
import {
  CapGainsEstimatesListing,
  CapGainsEstimatesRowSelection,
} from '@products/types/tax.type';
import { TranslateService } from '@shared/translate/translate.service';
import { FundShareClassId } from '@types';

export interface CapitaGainsCard {
  collapsedItems?: CapitalGainsCardItem[];
  expandedItems?: CapitalGainsCardItem[];
}
export interface CapitalGainsCardItem {
  info: InfoItem;
  highlight?: boolean;
}
@Component({
  selector: 'ft-distribution-capital-gains-cards',
  templateUrl: './distribution-capital-gains-cards.component.html',
})
export class DistributionCapitalGainsCardsComponent implements OnInit {
  @Input() cardData: CapGainsEstimatesListing;
  cardDataDetails: CapitaGainsCard = {};
  expanded: boolean;
  constructor(private translateService: TranslateService) {}

  ngOnInit(): void {
    this.createCards();
  }

  /**
   * Creats a singular card in an InfoItem format, picks up labels from translateService,
   * Also the value of cap gains is determined by the actualsAleart flag.
   */
  private createCards(): void {
    if (this.cardData) {
      this.cardDataDetails.expandedItems = [
        {
          info: {
            label: this.translateService.instant('pds.INCM_DIST_RECORD_DATE'),
            val: this.cardData.capitalGainRecordDate,
          },
        },

        {
          info: {
            label: this.translateService.instant(
              'products.capgains-table-heading-ex-date'
            ),
            val: this.cardData.capitalGainExDividendDate,
          },
        },
        {
          info: {
            label: this.translateService.instant(
              'products.capgains-table-heading-share-class'
            ),
            val: this.cardData.shareClassName,
          },
        },
      ];
      this.cardDataDetails.collapsedItems = [
        {
          info: {
            label: this.translateService.instant(
              'products.capgains-table-heading-long-term-cap-gains-perc'
            ),
            val: this.cardData.longTermCapitalGainPercent,
          },
          highlight: true,
        },

        {
          info: {
            label: this.translateService.instant(
              'products.capgains-table-heading-short-term-cap-gains-perc'
            ),
            val: this.cardData.shortTermCapitalGainPercent,
          },
          highlight: true,
        },
        {
          info: {
            label: this.translateService.instant(
              'products.capgains-table-heading-total-percent'
            ),
            val: this.cardData.totalGainNav,
          },
          highlight: true,
        },
        {
          info: {
            label: this.translateService.instant('pds.CAPGAIN_AMT_LONG_TERM'),
            val: this.cardData.actualsAlert
              ? this.translateService.instant('products.capgains-actualsposted')
              : this.cardData.longTermCapitalGainAmount,
          },
        },
        {
          info: {
            label: this.translateService.instant('pds.CAPGAIN_AMT_SHRT_TERM'),
            val: this.cardData.actualsAlert
              ? this.translateService.instant('products.capgains-actualsposted')
              : this.cardData.shortTermCapitalGainAmount,
          },
        },
        {
          info: {
            label:
              this.translateService.instant(
                'products.capgains-table-heading-nav-as-of'
              ) +
              ' ' +
              this.cardData.navAsofDate,
            val: this.cardData.navValue,
          },
        },
      ];
    }
  }

  /**
   * Sets the flag depends on clicking More Details | Less Details
   */
  public expandDetails(): void {
    this.expanded = !this.expanded;
  }
}
